import { PageHeader } from "@/components/PageHeader";
import { UploadCard } from "@/components/erp/UploadCard";

export default function ErpUploadsPage() {
  return (
    <div className="space-y-6" data-testid="erp-uploads-page">
      <PageHeader eyebrow="Data" title="Data Uploads" subtitle="Upload the Sales, Outstanding and Expenses reports. Columns are validated first; re-uploads replace only the dates (or months / as-of date) they contain." />
      <div className="grid gap-6 xl:grid-cols-3">
        {["sales", "outstanding", "expenses"].map((k) => <UploadCard key={k} kind={k} />)}
      </div>
      <p className="text-xs text-slate-500">Limits: 50 MB / 200,000 rows per file. Large files are processed in the background — keep this page open to follow progress.</p>
    </div>
  );
}
